import React from 'react';
import Navbar from "../components/Navbar";
import axios from "axios";
import LelangList from "../components/LelangList";
import LelangListFinish from "../components/LelangListFinish";
import Footer from "../components/Footer";
import {pageFilter, getArtistCookie} from "../data/page_data";
import Loading from "../components/loading";
import CssLoader from '../components/CssLoader';
import * as ReactGA from "react-ga";

class LelangPage extends React.Component {
    constructor(props) {
        super(props);
        this.pageData = pageFilter(this.props.artist, '../');
        this.state = {}
    }

    componentDidMount() {
        axios.get('/w/api/' + this.pageData.artist.id + '/lelang',{headers:{
          PortalAuth: getArtistCookie(this.props.artist)
        }})
            .then(response => {
                var respData = response.data;
                this.setState(state => ({data: respData}));
            })
        ReactGA.pageview(window.location.pathname + window.location.search);
    }

    render() {
        return <>
        <CssLoader css={this.pageData.artist.css}/>
            <Navbar data={this.pageData} title="LELANG"/>
            {!this.state.data ? <Loading/> :
                <div className="content lelang">
                    <div className="container">
            <h4>Tawar sekarang dari {this.pageData.artist.nick}!</h4>
                        <ul>
                            {
                                this.state.data.items.map((item, index) =>{
                                    return <LelangList data={item}/>
                                })
                            }

                        </ul>
                    </div>
                </div>
            }
            <Footer/>
        </>;
    }
}

export default LelangPage;